import { FC, useState } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('dp3.landing.WhatInBox');
    const textImgA = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718780284895/a5.png';
    const textImgB = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718780302139/a6.png';
    const textImgC = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718778567429/a4.png';
    const IS_EAST_ASIA = ['cn', 'jp'].includes(locale);

    let list = [
        {
            pc: IS_EAST_ASIA
                ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718874218463/c111%20(1).png'
                : locale === 'au'
                ? 'https://websiteoss.ecoflow.com/upload/image/1726667240005/b1.png'
                : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718778518246/a1.png',
            title: t('item1'),
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718778539446/a2.png',
            title: t('item2'),
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718778553535/a3.png',
            title: t('item3'),
        },
        {
            pc: IS_EAST_ASIA ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718874265058/c222.png' : textImgA,
            title: t('item4'),
        },
        {
            pc: IS_EAST_ASIA ? textImgC : textImgB,
            title: t('item5'),
        },
        {
            pc: IS_EAST_ASIA ? textImgB : textImgC,
            title: t('item6'),
        },
    ];

    if (IS_EAST_ASIA) {
        list = [
            {
                pc:
                    locale === 'cn'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1737790805612/13_1.png'
                        : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718874218463/c111%20(1).png',
                title: t('item1'),
            },
            {
                pc:
                    locale === 'cn'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1737790805799/13_2.png'
                        : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718778539446/a2.png',
                title: t('item2'),
            },
            {
                pc:
                    locale === 'cn'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1737790806368/13_3.png'
                        : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718778553535/a3.png',
                title: t('item3'),
            },
            {
                pc:
                    locale === 'cn'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1737790825303/13_4.png'
                        : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718874265058/c222.png',
                title: t('item4'),
            },
            {
                pc: locale === 'cn' ? 'https://websiteoss.ecoflow.com/upload/image/1737790805983/13_5.png' : textImgC,
                title: t('item5'),
            },
        ];
    }

    return (
        <div className={`${css.thecomp} GtmModuleData-section`} data-section-id={'dp3-WhatInBox'} data-section-title={t('title')}>
            <div className="dp3-title">{t('title')}</div>
            <div className={`comp-module ${IS_EAST_ASIA ? 'asia' : ''}`}>
                {list.map((item, index) => (
                    <div key={index} className={`comp-item comp-item-${index + 1}`} style={locale === 'cn' ? { gridArea: `a${index}` } : {}}>
                        <div className="comp-item-title">{item.title}</div>
                        <div className="comp-item-img">
                            <EditorImg pc={item.pc} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TheComp;
